// extracted by mini-css-extract-plugin
export default {"input":"CollectingMail_input__V4cle","word":"CollectingMail_word__1zpmD"};